import React, { Fragment, useEffect, useState } from 'react';
import MaterialTable from 'material-table';

import { config, tableColumns, tableIcons, BACKEND_URL } from '../services/config';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import { userState } from '../atoms/userAtom';

export default function WorkTable() {
  const [data, setData] = useState();
  const [worker, setWorker] = useState([]);
  const [userToken, setUserToken] = useRecoilState(userState);
  useEffect(() => {
    if (userToken !== '') {
      getJobsHandler();
      getWorkerHandler();
    }
  }, [userToken]);
  const getJobsHandler = async () => {
    axios
      .get(`${BACKEND_URL}/api/v1/job`, config(userToken))
      .then((res) =>
        setData(
          res.data.map((d) => ({
            ...d,
            worker: d?.worker?.id,
            coworker: d?.coworker?.id,
          }))
        )
      )
      .catch((err) => console.log(err));
  };
  const getWorkerHandler = async () => {
    axios
      .get(`${BACKEND_URL}/api/v1/worker`, config(userToken))
      .then((res) =>
        setWorker(
          res.data
            .filter((w) => !w.sick && !w.holiday) // Filter out sick or on holiday workers
            .map((w) => ({ [w.id]: w.name }))
            .reduce((r, c) => Object.assign(r, c), {})
        )
      )
      .catch((err) => console.log(err));
  };
  const addWorkHandler = async (data) =>
    axios
      .post(`${BACKEND_URL}/api/v1/job`, data, config(userToken))
      .then(() => getJobsHandler())
      .catch((err) => console.log(err));
  const updateWorkHandler = async (data) =>
    axios
      .put(`${BACKEND_URL}/api/v1/job/${data._id}`, data, config(userToken))
      .then(() => getJobsHandler())
      .catch((err) => console.log(err));
  const deleteWorkHandler = (id) =>
    axios
      .delete(`${BACKEND_URL}/api/v1/job/${id}`, config(userToken))
      .then(() => getJobsHandler())
      .catch((err) => console.log(err));
  return (
    <Fragment>
      <MaterialTable
        columns={tableColumns(worker)}
        data={data}
        title="Job planning"
        options={{ search: false, filtering: false, pageSize: 20 }}
        icons={tableIcons}
        editable={{
          onRowAdd: (newData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                addWorkHandler(newData)
                  .then((res) => console.log(res))
                  .catch((err) => console.log(err));
                resolve();
              }, 1000);
            }),
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                const dataUpdate = [...data];
                const index = oldData.tableData.id;
                dataUpdate[index] = newData;
                updateWorkHandler(newData)
                  .then((res) => console.log(res))
                  .catch((err) => console.log(err));
                setData([...dataUpdate]);

                resolve();
              }, 1000);
            }),
          onRowDelete: (oldData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                const dataDelete = [...data];
                const index = oldData.tableData.id;
                dataDelete.splice(index, 1);
                deleteWorkHandler(oldData._id)
                  .then((res) => getJobsHandler())
                  .catch((err) => console.log(err));
                setData([...dataDelete]);

                resolve();
              }, 1000);
            }),
        }}
      />
    </Fragment>
  );
}
